import React from "react";
import MyDetails from "./mydetails";
import ExternalIdentities from "../../components/externalidentities/externalidentities";
import { routes } from "utilities/routing/generatedRoutes";
import OptionsPanel from "components/panels/OptionsPanel";
import { getCultureFromLcid } from "utilities/enumutils";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";

interface Props {
  menuItems: server.dto.OptionMenuGroup[]
  config: server.dto.UserDetailPanelConfig
}

const MyDetailsPanel = (props: Props) => {
  const { user, toClients, googleConnectAbsolute } = props.config;
  const tz = getTimeZoneFromIana(user.ianaTimeZoneId, serverReference.culture.uiLocale);
  return <OptionsPanel
    title={<MyDetails
      user={user.user}
      changeAvatar
      changeNameUrl={routes.personal_ChangeName().absolute}
    />}
  >
    <div className="my-details-content">
      <div className="my-details-content-section">
        <div className="my-details-row">
          <p className="my-details-row-label body-text-regular">{RESX.SoUser.Username}</p>
          <a href={routes.personal_ChangeName().absolute} className="my-details-row-value subtitle-text-semibold">{user.username}</a>
        </div>

        <div className="my-details-row">
          <p className="my-details-row-label body-text-regular">{RESX.DateTime.Timezone}</p>
          <a href={routes.preference_RegionalSettings().absolute} className="my-details-row-value subtitle-text-semibold">{formatTimeZone(tz)}</a>
          <p className="label-text-regular">{tz.value}</p>
        </div>

        <div className="my-details-row">
          <p className="my-details-row-label body-text-regular">{RESX.Language.resxLanguage}</p>
          <a href={routes.preference_RegionalSettings().absolute} className="my-details-row-value subtitle-text-semibold">{getCultureFromLcid(user.user.culture).text}</a>
        </div>

        <div className="my-details-row">
          <p className="my-details-row-label body-text-regular">{RESX.GeneralLabels.Email}</p>
          <a href={routes.personal_EmailSettings().absolute} className="my-details-row-value subtitle-text-semibold">{user.email}</a>
        </div>
      </div>

      <div className="my-details-content-section">
        <div className="my-details-row">
          <p className="my-details-row-label body-text-regular">{RESX.SoUser.MemberOf}</p>

          <div className="flex-column gap-small">
            <p className="my-details-row-value nav-text-semibold">{toClients[0].client.name}</p>
            <p className="label-text-regular">{toClients[0].environment}</p>
          </div>
        </div>
      </div>

      <div className="my-details-content-section">
        <ExternalIdentities
          googleConnectAbsolute={googleConnectAbsolute}
          allowDisconnect={false}
          settingsUrl={routes.personal_ConnectedAccount_List().absolute} />
      </div>

    </div>

  </OptionsPanel>;
};

export default MyDetailsPanel;